$(function () {
    //ALF: setTimeout is needed due to page load order
    setTimeout(function() {
        if ($.urlParam('productTypeChosen') === 'True') {
            scrollToElement('#channel-hopper-container-experience', 100);
        }
    }, 0);
});


function scrollToElement(element, speed) {
    $('html, body').animate({
        scrollTop: $(element).offset().top
    }, speed);
}

$.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
        return null;
    } else {
        return results[1];
    }
};